module.exports = __webpack_public_path__ + "img/v3-property-editor.452a556c.png";